import InstructionCard from "./InstructionCard"

const SpecificInstruction = ({orderComments, instruction, orderStatus, options}) => {

  const comments = options || orderComments?.[instruction];
  if (!comments?.length) return null;

  // Sort by time descending if not pre-sorted via options
  const sorted = options 
    ? comments 
    : [...comments].sort((a, b) => new Date(b?.time) - new Date(a?.time));

  return sorted.map((comment, index) => (
    <InstructionCard key={index}
      status={orderStatus}
      pickupComments={comment}
    />
  ))
}

export default SpecificInstruction